import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from 'app/api';
import produce from 'immer';
import convertSellerBidsDetail from 'app/libs/sellerBidsDetailConverter';
import { dayjs } from '@encarpkg/shared';

const GET_AUCTION_LIST = 'estimate/GET_AUCTION_LIST';
export const getAuctionList = createAction(GET_AUCTION_LIST, api.getAuctionList);

const GET_AUCTION_DETAIL = 'estimate/GET_AUCTION_DETAIL';
export const getAuctionDetail = createAction(GET_AUCTION_DETAIL, api.getAuctionDetail);

const GET_PRO_AUCTION_LIST = 'estimate/GET_PRO_AUCTION_LIST';
export const getProAuctionList = createAction(GET_PRO_AUCTION_LIST, api.getProAuctionList);

const GET_PRO_AUCTION_DETAIL = 'estimate/GET_PRO_AUCTION_DETAIL';

export const getProAuctionDetail = createAction(GET_PRO_AUCTION_DETAIL, async (sellerUniqueId, temporaryId) => {
	const response1 = await api.getProAuctionDetail(sellerUniqueId, temporaryId);
	const { estimateProDetail, meta, instantPurchaseType, salesMethod, instantOfferEligibilityResponse } = response1?.data || {};

	const notBiddingEnd = dayjs().isBefore(dayjs(estimateProDetail?.bidding?.biddingEndDateTime));

	const isBidding = meta?.status?.name === 'PRO_IN_AUCTION';
	const isWaitRequestSell = meta?.status?.name === 'PRO_AUCTION_COMPLETE_NOT_CHOICE';

	const isDiagnosisBaroBuy = instantPurchaseType === 'DIAGNOSIS_INSTANT_PURCHASE';
	const isBaroBuy = salesMethod === 'INSTANT_PURCHASE';

	const hasInstantOfferPrice = instantOfferEligibilityResponse?.instantOfferPrice > 0;

	return {
		...response1,
		data: {
			...response1.data,
			// 믿고 경매 진행중 인스턴트 오퍼 여부
			isAbleTransferInstant: hasInstantOfferPrice && notBiddingEnd && isBidding,
			// 믿고 선택 대기중 인스턴트 오퍼 여부
			isAbleWaitRequestSellTransferInstant: hasInstantOfferPrice && isWaitRequestSell,
			instantOfferPrice: instantOfferEligibilityResponse?.additionalPrice || 0,
			isDiagnosisBaroBuy,
			isBaroBuy,
			isBaro: isBaroBuy || isDiagnosisBaroBuy,
		},
	};
});

const GET_SELLER_ESTIMATE_DETAIL = 'estimate/GET_SELLER_ESTIMATE_DETAIL';
export const getSellerEstimateDetail = createAction(GET_SELLER_ESTIMATE_DETAIL, async (estimateId, sellerUniqueId) => {
	const response = await api.getSellerBidsDetail(estimateId, sellerUniqueId);

	return { ...response, data: convertSellerBidsDetail(response.data) };
});

const GET_BID_DETAIL = 'estimate/GET_BID_DETAIL';
export const getBidDetail = createAction(GET_BID_DETAIL, api.getBidDetailInReadServer);

const initialState = {
	auctionList: [],
	auctionDetail: {},
	proAuctionList: [],
	proAuctionDetail: {},
	sellerEstimateDetail: {},
	bidDetail: {},
};

export default handleActions(
	{
		...pender({
			type: GET_AUCTION_LIST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.auctionList = data || [];
				}),
		}),

		...pender({
			type: GET_AUCTION_DETAIL,

			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					if (!data?.estimate) {
						draft.auctionDetail = {};
						return;
					}

					const detail = data.estimate;

					// 검수 중, 검수 완료 상태에서의 재견적
					const isRemakeTradeInDealConfirm =
						(detail.sellerResult?.code === 'DEAL_IN_PROGRESS' || detail.sellerResult?.code === 'DEAL_SUCCESS') &&
						detail.proresult === '51';

					draft.auctionDetail = {
						...detail,
						isRemakeTradeInDealConfirm,
					};
				}),
		}),
		...pender({
			type: GET_PRO_AUCTION_LIST,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.proAuctionList = data?.estimateProList || [];
				}),
		}),

		...pender({
			type: GET_PRO_AUCTION_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.proAuctionDetail = data || {};
				}),
		}),

		...pender({
			type: GET_SELLER_ESTIMATE_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					draft.sellerEstimateDetail = data || {};
				}),
		}),

		...pender({
			type: GET_BID_DETAIL,
			onSuccess: (state, action) =>
				produce(state, (draft) => {
					const { data } = action.payload;
					const [first] = data || [];

					if (first) {
						draft.bidDetail = {
							...first,
							dealer_nm: first.dealerName,
							dealer_region: first.dealerRegion,
							try_price: first.bidPrice,
							try_rank: first.tryRank,
							grade: first.dealerReviewGrade,
							adjust_agree_flag: first.adjustAgreeFlag,
							estimate_id: first.estimateId,
							carnum: first.carNumber,
						};
					} else {
						draft.bidDetail = {};
					}
				}),
		}),
	},
	initialState,
);
